import {Vue, Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import Icon from '@/components/Icon';
import './style.less';

interface IMenuButtonProps {
  iconName: string;
  name: string;
  click?: any;
  showDot?: boolean;
}

@Component
export default class MenuButton  extends tsx.Component<IMenuButtonProps> {
  
  @Prop() public iconName!: string
  @Prop() public name!: string
  @Prop() public click!: any
  @Prop({default: false}) public showDot!: boolean
  
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {click = () => {}, iconName, name, showDot} = this.$props;
    return (
      <div onClick={click} class='menuButton-container'>
        <Icon name={iconName} />
        <span class='menuButton-text'>
          {name}
          {showDot? <span class='menu-dot'></span> : null}
        </span>
      </div>
    )
  }
  
}